import { inject } from '@angular/core';
import { Auth } from '@angular/fire/auth';
import { CanActivateFn, Router } from '@angular/router';
import { doc, Firestore, getDoc } from '@angular/fire/firestore';

export const schemasAdminGuard: CanActivateFn = async (route, state) => {
  const auth = inject(Auth);
  const firestore = inject(Firestore);
  const router = inject(Router);

  try {
    const user = await auth.currentUser;
    if (!user?.uid) {
      router.navigate(['/auth'], {
        queryParams: { returnUrl: state.url }
      });
      return false;
    }

    const adminRef = doc(firestore, 'schemas_admins', user.uid);
    const adminSnap = await getDoc(adminRef);

    if (!adminSnap.exists()) {
      router.navigate(['/schemas'], {
        queryParams: { access_denied: 'schemas_admin' }
      });
      return false;
    }

    return true;
  } catch {
    router.navigate(['/schemas'], {
      queryParams: { access_denied: 'schemas_admin' }
    });
    return false;
  }
};
